var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn-group btn-group-sm item-list-per-page" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-light dropdown-toggle",
          attrs: {
            disabled: _vm.loading,
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "true",
            id: "dropdownActions",
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.perPage) +
              " " +
              _vm._s(_vm.$t("per page")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-menu",
          attrs: { "aria-labelledby": "dropdownActions" },
        },
        _vm._l(_vm.values, function (value) {
          return _c(
            "button",
            {
              staticClass: "dropdown-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("change-per-page", value)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(value) + "\n        ")]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }